export const TAX = 1.08
export const EAT_IN_TAX = 1.1
